import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MetricsOverview from './MetricsOverview';
import InstrumentPanel from './InstrumentPanel';
import CrossInstrument from './CrossInstrument';

// `:instrumentKey` is deliberately open-ended rather than one route per
// instrument. The panel renders whatever the registry declares -- labels,
// scales, value names, wording -- so the three assessment protocols still to be
// integrated need a registry entry and no front-end change at all. An unknown
// key is the server's 404, surfaced by the panel.
const MetricsSection = () => (
  <Routes>
    <Route index element={<MetricsOverview />} />
    <Route path="cross-instrument" element={<CrossInstrument />} />
    <Route path=":instrumentKey" element={<InstrumentPanel />} />
  </Routes>
);

export default MetricsSection;
